var IpixEnquiry = function () {

    var validateHeaderForm = function (e) {
        IpixJson.options.FormValidation.fields = {
            'name': {
                validators: {
                    notEmpty: {
                        message: 'Please enter name'
                    }
                }
            },
            'email': {
                validators: {
                    emailAddress: {
                        message: 'Please enter valid email address'
                    },
                    notEmpty: {
                        message: 'Please enter email address'
                    }
                }
            },
            'mobile': {
                validators: {
                    phone: {
                        message: 'Please enter valid phone number'
                    },
                    numeric: {
                        message: 'Please enter valid phone number',
                    },
                    notEmpty: {
                        message: 'Please enter phone number'
                    },
                }
            },
            // 'service_id': {
            //     validators: {
            //         callback: {
            //             message: 'Please select product/service',
            //             callback: function (value, validator, $field) {
            //                 if ($("#headerForm").find("input[name=product_id]").val() === "" && $("#headerForm").find("input[name=service_id]").val() === "") {
            //                     return false;
            //                 } else {
            //                     return true;
            //                 }
            //             }
            //         }
            //     }
            // },
        };
        IpixJson.validators['headerForm'] = FormValidation.formValidation(document.getElementById('headerForm'), IpixJson.options.FormValidation);
    }

    var validateForm = function (e) {
        IpixJson.options.FormValidation.fields = {
            'name': {
                validators: {
                    notEmpty: {
                        message: 'Please enter name'
                    }
                }
            },
            'email': {
                validators: {
                    emailAddress: {
                        message: 'Please enter valid email address'
                    },
                    notEmpty: {
                        message: 'Please enter email address'
                    }
                }
            },
            'mobile': {
                validators: {
                    phone: {
                        message: 'Please enter valid phone number'
                    },
                    numeric: {
                        message: 'Please enter valid phone number',
                    },
                    notEmpty: {
                        message: 'Please enter phone number'
                    },
                }
            },
            // 'service_id': {
            //     validators: {
            //         callback: {
            //             message: 'Please select product/service',
            //             callback: function (value, validator, $field) {
            //                 if ($(".enquiry-form").find("input[name=product_id]").val() === "" && $(".enquiry-form").find("input[name=service_id]").val() === "") {
            //                     return false;
            //                 } else {
            //                     return true;
            //                 }
            //             }
            //         }
            //     }
            // },
        };

        if (document.getElementsByClassName('enquiry-form').length) {
            var form = document.getElementsByClassName('enquiry-form')[0];

            IpixJson.validators['contactForm'] = FormValidation.formValidation(form, IpixJson.options.FormValidation);
        }
    }

    var validateEventForm = function (e) {
        IpixJson.options.FormValidation.fields = {
            'name': {
                validators: {
                    notEmpty: {
                        message: 'Name is Mandatory'
                    }
                }
            },
            'email': {
                validators: {
                    emailAddress: {
                        message: 'The value is not a valid email address'
                    },
                    notEmpty: {
                        message: 'Email address is Mandatory'
                    }
                }
            },
            'mobile': {
                validators: {
                    phone: {
                        message: 'The value is not a valid phone number'
                    },
                    numeric: {
                        message: 'The value is not a number',
                    },
                    notEmpty: {
                        message: 'Phone number is required'
                    },
                }
            },
        };

        if (document.getElementsByClassName('enquiry-form').length) {
            var form = document.getElementsByClassName('enquiry-form')[0];

            IpixJson.validators['eventForm'] = FormValidation.formValidation(form, IpixJson.options.FormValidation);
        }
    }

    // var initProductSelect = function () {
    //     // Get all the product and service buttons
    //     const productButtons = document.querySelectorAll('.productSelect');

    //     // Add click event listeners to each product button
    //     productButtons.forEach((button) => {
    //         button.addEventListener('click', () => {
    //             productButtons.forEach((btn) => {
    //                 btn.classList.remove('active');
    //                 btn.classList.remove('select');
    //             });
    //             button.classList.add('active');
    //             var selectedProduct = button.getAttribute('data-product_id');
    //             $(button).parents('form').find('input[name="product_id"]').val(selectedProduct);
    //             $(button).toggleClass('select');
    //         });
    //     });
    // }

    // var initServiceSelect = function () {
    //     const serviceButtons = document.querySelectorAll('.serviceSelect');

    //     // Add click event listeners to each service button
    //     serviceButtons.forEach((button) => {
    //         button.addEventListener('click', () => {
    //             serviceButtons.forEach((btn) => {
    //                 btn.classList.remove('active');
    //                 btn.classList.remove('select');
    //             });
    //             button.classList.add('active');
    //             var selectedService = button.getAttribute('data-service_id');
    //             console.log($(button), selectedService);
    //             $(button).parents('form').find('input[name="service_id"]').val(selectedService);
    //             $(button).toggleClass('select');
    //         });
    //     });
    // }

    return {
        init: function () {
            validateHeaderForm();
            validateForm();
            // validateEventForm();
            // initProductSelect();
            // initServiceSelect();
        }
    }
}();

IpixUtil.onDOMContentLoaded(function () {
    IpixEnquiry.init();
});
